import { styled as t } from "styled-components";
const a = t.tr`
  height: auto;
`;
export {
  a as TableDataRow
};
